var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.PageWrapper,_vm._b({tag:"component",staticClass:"outline-none",attrs:{"content":_vm.content}},'component',Object.assign({}, _vm.props, {page: _vm.page}),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }